import StarFilled20 from '@carbon/icons-react/es/star--filled/20';
import React, { FC, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { Rate } from 'components/atoms/rate';
import { StarRatingConfigValues } from 'components/organisms/templates/forms/form-builder/constants';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FieldsErrorRenderer,
  FormFieldProps,
} from './form-elements';

const StyledRate = styled(Rate)`
  margin-top: var(--spacing-03);
  .ant-rate-star {
    background: var(--coolest-gray-10);
    border-radius: 3px;
    &:not(:last-child) {
      margin-right: var(--spacing-03);
    }
    > div[role='radio'] {
      padding: var(--spacing-03);
    }
    &.ant-rate-star-full {
      background: var(--private-02);
    }
  }
  .ant-rate-star-second {
    color: var(--gray-20);
  }
  .ant-rate-star-full .ant-rate-star-second {
    color: var(--warning-border-color);
  }
  @media screen and (max-width: 480px) {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fit, 1fr);
    column-gap: var(--spacing-02);
    overflow-x: auto;
    .ant-rate-star {
      > div[role='radio'] {
        padding: var(--spacing-01);
        text-align: center;
      }
      &:not(:last-child) {
        margin-right: 0;
      }
    }
  }
`;

export const RatingField: FC<FormFieldProps> = ({
  field,
  control,
  setValue,
  errors,
  disabled,
}) => {
  const defaultRatingCount = useMemo(() => {
    return field.questionMeta?.numberOfStar ?? StarRatingConfigValues[0];
  }, [field.questionMeta]);

  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <FormItemDesc label={field.description} />

      <Controller
        control={control}
        rules={{ required: field.required }}
        name={field.questionId.toString()}
        shouldUnregister
        render={(props) => (
          <div
            ref={props.field.ref}
            data-cy={`${field.questionText}-rating-wrapper`}
          >
            <StyledRate
              character={<StarFilled20 />}
              allowHalf={false}
              count={defaultRatingCount}
              value={props.field.value ?? 0}
              allowClear
              disabled={disabled}
              onChange={(value) => {
                setValue?.(field.questionId.toString(), value);
              }}
            />
          </div>
        )}
      />

      <FieldsErrorRenderer errors={errors} questionId={field.questionId} />
    </FormItemWrapper>
  );
};
